// The client's own URL (/client/<slug>) is where its users start and return to.
// Falls back to the generic /login page when no client is known.
export const getClientHomePath = (client?: { client_website_link?: string } | null) =>
    client?.client_website_link
        ? `/client/${encodeURIComponent(client.client_website_link)}`
        : "/login";
